import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hire-microsoft-dotnet-dev',
  templateUrl: './hire-microsoft-dotnet-dev.component.html',
  styleUrls: ['./hire-microsoft-dotnet-dev.component.css']
})
export class HireMicrosoftDotnetDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/hire-microsoft-dotnet-dev/hire-microsoft-dotnet-dev.component.ts